import { Image } from "antd";
import { useNavigate } from "react-router-dom";
import EditIcon from "../../images/Edit";
import ViewIcon from "../../images/View";
import { serverImgFullPath } from "../../../utils/Common";
import TickIcon from "../../images/Tick";
import { useState } from "react";
import ConfirmModal from "../../modals/ConfirmModal";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import QrModal from "../../modals/QrModal";
import DiningIcon from "../../images/DiningTable";

export default function BranchListItemComponent({
  setIsBranchStatusChange,
  records = {
    data: {
      branchId: "",
      restaurantId: "",
      restaurantName: "",
      branchName: "",
      logo: "",
      address: "",
      phoneCountryCode: "",
      phone: "",
      branchStatus: "",
      slug: "",
      inventoryType: "",
      openingDate: ""
    },
  },
}) {
  const { data } = records;
  const { branchId, restaurantId, openingDate, branchName, logo, address, branchStatus, slug, inventoryType, tableManagement } = data;
  const { user, showNotification, setNetworkCall } = useUserStore();
  const navigate = useNavigate();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isOpenQrModal, setIsOpenQrModal] = useState(false);
  const [qrData, setQrData] = useState({});

  const dataQr = {
    id: branchId,
    name: branchName,
    slug: slug,
    logo: logo,
    isRestaurant: true,
    totalTableInRestaurant: 1,
  };

  function getModalMessage(status) {
    if (Boolean(status) && status === "Pending") {
      return `Are you sure want to activate the ${branchName} branch!`;
    }
    return `Are you sure want to deactivate the ${branchName} branch!`;
  }

  function onHandleBranchEdit(restaurantId, branchId) {
    navigate(`/restaurants/${restaurantId}/branch/${branchId}/edit`);
  }

  function onHandleBranchView(restaurantId, branchId) {
    navigate(`/restaurants/${restaurantId}/branch/${branchId}/details`);
  }

  function onHandleFloorView(restaurantId, branchId, tableManagement) {
    if (tableManagement !== 'Active') {
      showNotification("First activate table management from settings and then proceed from here to setup floor plan.");
      return;
    }

    navigate(`/restaurants/${restaurantId}/branch/${branchId}/floor-plan`);
  }

  function onHandleDeleteBranch() {
    setIsConfirmModalOpen(true);
  }

  async function onHandleBranchDeleteOk() {
    let tempStatus = "";
    if (branchStatus === "Pending") {
      tempStatus = "Published";
    } else {
      tempStatus = "Pending";
    }

    const data = {
      status: tempStatus,
    };

    const formData = new FormData();
    formData.append("status", data.status);

    const params = {
      branchId: branchId,
      data: formData,
    };

    setIsConfirmModalOpen(false);
    setNetworkCall(true);
    const token = user.token.token;

    try {
      const response = await ApiService.UPDATE_BRANCH(params, token);

      if (!response || response.code !== 200) {
        setNetworkCall(false);
        showNotification(response.message);
        return;
      }

      setNetworkCall(false);
      // For rerendering the branches
      setIsBranchStatusChange(true);
      showNotification(`${branchName} branch status changed successfully.`, false);
    } catch (err) {
      showNotification(err.response.data.message);
    } finally {
      setNetworkCall(false);
    }

  }

  function onHandleBranchDeleteCancel() {
    setIsConfirmModalOpen(false);
  }


  function onHandleQrSubmit() { }

  function onHandleQrCancel() {
    setIsOpenQrModal(false);
  }


  const navigateToQrPage = () => {
    navigate("/restaurant-qr", { state: { qrData: dataQr } });
    window.location.reload();
  };

  return (
    <section>
      <div className="w-full h-[107px] mt-[40px]">
        <div className="bg-[#F1F1F1] flex items-center w-full h-full rounded-lg pl-[32px]">
          {/* logo */}
          <div
            className="h-[74px] w-[74px] bg-[#FCBD10] 
              flex items-center justify-center rounded-full"
          >
            <Image
              src={serverImgFullPath(logo)}
              alt="logo"
              width={74}
              height={74}
              preview={false}
              fallback="/images/temp-restaurant-logo.jpg"
              className="w-full h-full rounded-full"
            />
          </div>

          <div
            className="flex items-center space-x-[20px] w-full 
          h-full pr-[51px]"
          >
            <div className="pl-[36px] w-[30%]">
              <div className="text-[#696969] h-full leading-[14.4px] flex">
                <span className="font-p_bold text-[18px] word-break">
                  {branchName}
                </span>
              </div>
              <p className="text-[12px] mt-3 font-p_regular leading-[14.4px] text-[#696969]">
                {address}
              </p>
            </div>

            <div className="w-[15%] text-right">
              <div
                className="text-[14px] font-p_bold leading-[16px] tracking-[0.58px] mb-[3px] text-red-600"
              >
                {inventoryType === 'INGREDIENT' ? 'Ingredient wise inventory' : 'Item wise inventory'}
              </div>
            </div>

            <div className="w-[15%] text-right">
              <div
                className="text-[14px] font-p_bold leading-[16px] tracking-[0.58px] mb-[3px] 
              text-[#2EC114]"
              >
                {openingDate}
              </div>
              <div className="">
                <div
                  className={`${branchStatus === "Pending"
                    ? "text-[#FCBD10]"
                    : "text-[#2EC114]"
                    } font-p_bold leading-[16px] 
                tracking-[0.58px] text-[14px] cursor-default`}
                >
                  {branchStatus}
                </div>

              </div>
            </div>

            <div className="w-[45%] flex items-center justify-end space-x-[6px]">
              <ViewIcon
                attributes={{
                  color: "#2EC114",
                  size: "36",
                  classes: "cursor-pointer",
                }}
                clickHandler={() =>
                  onHandleBranchView(
                    restaurantId,
                    branchId
                  )
                }
              />
              
              <DiningIcon
                attributes={{
                  color: "#2EC114",
                  size: "36",
                  classes: "cursor-pointer",
                }}
                clickHandler={() =>
                  onHandleFloorView(
                    restaurantId,
                    branchId,
                    tableManagement
                  )
                }
              />

              <div onClick={navigateToQrPage}>
                <Image
                  preview={false}
                  alt="Generate QR"
                  width={36}
                  height={36}
                  className="cursor-pointer pt-[2px]"
                  src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/qr-logo.svg"}
                />
              </div>

              {/* <QrIcon
                attributes={{
                  color: "gold",
                  size: "36",
                  classes: "cursor-pointer",
                }}
                clickHandler={onHandleGenerateQr}
              /> */}
              <EditIcon
                attributes={{
                  color: "#572D86",
                  size: "36",
                  classes: "cursor-pointer",
                }}
                clickHandler={() =>
                  onHandleBranchEdit(
                    restaurantId,
                    branchId
                  )
                }
              />
              <TickIcon
                attributes={{
                  color: `${branchStatus === "Pending"
                    ? "#828282"
                    : "#2EC114"
                    }`,
                  size: "40",
                  classes: "cursor-pointer",
                }}
                clickHandler={onHandleDeleteBranch}
              />
            </div>
          </div>
        </div>
      </div>

      <ConfirmModal
        isModalOpen={isConfirmModalOpen}
        records={{
          title: "Confirm",
          handleOk: onHandleBranchDeleteOk,
          handleCancel: onHandleBranchDeleteCancel,
          message: getModalMessage(branchStatus),
          // message: modalMessage,
          isClosable: false,
          confirmText: "Yes",
          cancelconfirmText: "No",
        }}
      />

      <QrModal
        openModal={isOpenQrModal}
        record={{
          onFinish: onHandleQrSubmit,
          onCancel: onHandleQrCancel,
          param: qrData,
        }}
      />
    </section>
  );
}
